import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PeriodicalsManagementList from "./PeriodicalsManagementList";
import { RouteGuard } from "../../guards/RouteGuard";
function PeriodicalsManagement() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(PeriodicalsManagementList, null))); } })));
}
export default PeriodicalsManagement;
